import React, { Component } from "react";
import { Portal } from "react-portal";
import FadeIn from "react-lazyload-fadein";
import InnerImageZoom from 'react-inner-image-zoom';


export default class ProductGalleryImage extends React.Component {

	render() {
		
		return (
			<div onClick={this.handleZoom}> 
				<InnerImageZoom
					src={this.props.slide.src}
					zoomSrc={this.props.slide.srclrg}
					zoomType="hover"
					zoomPreload={true}
				/>
			</div>
			
		)
	}
}